<template>
  <modal :state="state" :index="index" @toggle-modal="emitHideModal">
    <div slot="body">
      <h3 class="modal-title">{{errorTitle}}</h3>
      <p>{{errorMessage}}</p>
      <div class="cta">
        <button type="button" @click="emitHideModal" class="btn block green">Close</button>
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
  import Vue from "vue";

  export default Vue.extend({
    props: {
      state: Object,
      errorTitle: String,
      errorMessage: String,
    }
  });
</script>
